/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React, Suspense } from "react";
import * as ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import history from "./utils/history";
import * as serviceWorker from "./service-worker";
import App from "./App";
import Loading from "./components/common/Loading/Loading";
import "./styles/index.scss";
import { default as ToastProvider } from "./Providers/ToastProvider";
import { I18nextProvider } from "react-i18next";
import { i18nInstance } from "./utils/i18n/i18n";

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <I18nextProvider i18n={i18nInstance}>
      <Router history={history}>
        <ToastProvider>
          <App />
        </ToastProvider>
      </Router>
    </I18nextProvider>
  </Suspense>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
